import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import type { ReactNode } from "react";
import { formatNumber } from "../utils/format.ts";

interface SectionHeadingProps {
  title: ReactNode;
  /** A grey number after the title. */
  count?: number;
  /** Right-aligned: a small button or link. */
  action?: ReactNode;
}

/** The heading over a page section that isn't its own card (a second table, a list of rows). */
export default function SectionHeading({ title, count, action }: SectionHeadingProps) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, mb: 1 }}>
      <Typography variant="subtitle1" component="h2" sx={{ fontWeight: 600 }}>
        {title}
        {count != null && (
          <Typography component="span" variant="inherit" sx={{ color: "text.secondary", fontWeight: 500, ml: 1 }}>
            {formatNumber(count)}
          </Typography>
        )}
      </Typography>
      {action}
    </Box>
  );
}
